import { API } from "../../backend";

export const getProducts = async (page) => {
    try {

        const respones = await fetch(`${API}products?page=${page}`,
            {
                method: "GET",
            })

        return respones.json()

    } catch (e) {
        console.log("Error: ", e);
    }
}